import React from 'react';
import { Link } from 'react-router-dom';
import { blogPosts } from '../data/blogPosts';

const BlogSection = () => {
  return (
    <section id="blog" className="perf-section bg-stone-50 py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 max-w-3xl space-y-4">
          <span className="text-sm font-medium uppercase tracking-widest text-stone-500">Journal</span>
          <h2 className="text-5xl font-bold leading-tight text-stone-900 md:text-6xl">
            Wedding Photography Articles For Indian Couples
          </h2>
          <p className="text-lg text-stone-600">
            These article pages target long-tail search terms around wedding photography in India, Kolkata,
            pre-wedding shoots, and pricing. They are structured to support stronger organic visibility than a
            homepage-only portfolio.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          {blogPosts.map((post) => (
            <article key={post.slug} className="rounded-3xl border border-stone-200 bg-white p-8 shadow-sm">
              <div className="mb-5 flex items-center justify-between gap-3 text-sm text-stone-500">
                <span className="rounded-full bg-stone-100 px-3 py-1 font-medium text-stone-700">{post.category}</span>
                <span>{post.readTime}</span>
              </div>
              <h3 className="mb-4 text-2xl font-bold leading-tight text-stone-900">{post.title}</h3>
              <p className="mb-6 text-base leading-7 text-stone-600">{post.description}</p>
              <div className="mb-6 flex flex-wrap gap-2">
                {post.keywords.map((keyword) => (
                  <span
                    key={keyword}
                    className="rounded-full border border-stone-200 bg-stone-50 px-3 py-1 text-xs text-stone-700"
                  >
                    {keyword}
                  </span>
                ))}
              </div>
              <Link
                to={`/blog/${post.slug}`}
                className="inline-flex items-center rounded-full bg-stone-900 px-5 py-3 text-sm font-semibold text-white transition-colors duration-200 hover:bg-stone-800"
              >
                Read Article
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
